<template>
  <div style="position: relative; width: 100%">
    <el-dropdown max-height="20vh" placement="bottom-start" ref="dropdownRef" trigger="contextmenu" @command="updateOrganizationDropdown">
      <div class="dropdown-input-area"></div>
      <template #dropdown>
        <el-dropdown-menu style="max-height: 20vh">
          <el-dropdown-item v-for="(option, index) in suggestedOptions" :key="index" :command="option" :disabled="option.disabled" :class="option.class">
            {{ option.value ? option.value : `${option.title} - ${option.inn}` }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <el-input :disabled="props.disabledCustom" :model-value="props.organization" @input="inputOrganization" placeholder="Введите организацию" v-cancel-read-only autocomplete="do-not-autofill" />
  </div>
</template>

<script setup>
import { getSuggestedInnAndOrganizations } from '@/utils/getDataForm';
import { debounce } from '@/utils/setDebounce';
import { ref } from 'vue';

const suggestedOptions = ref([]);
const dropdownRef = ref();

const props = defineProps({
  organization: String,
  disabledCustom: Boolean,
});
const emit = defineEmits(['update:organization', 'setInn']);

const updateOrganizationDropdown = (value) => {
  emit('setInn', value.inn);
  emit('update:organization', value.title);
};

async function getSuggestedOptions(value) {
  if (value.length > 2) {
    try {
      suggestedOptions.value = await getSuggestedInnAndOrganizations(value);

      if (suggestedOptions.value.length < 1) {
        suggestedOptions.value[0] = {
          disabled: 'true',
          class: 'disable-notice',
          value: 'Нет результатов',
        };

        dropdownRef.value.handleOpen();
      } else {
        suggestedOptions.value.unshift({
          disabled: 'true',
          class: 'disable-notice',
          value: 'Выберите нужную организацию',
        });
        dropdownRef.value.handleOpen();
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    dropdownRef.value.handleClose();
  }
}

const getOptionsDebounce = debounce(getSuggestedOptions, 500);

const inputOrganization = (value) => {
  emit('update:organization', value);
  if (props.organization.length <= 1) {
    dropdownRef.value.handleClose();
    suggestedOptions.value = [];
  } else {
    dropdownRef.value.handleOpen();
    suggestedOptions.value[0] = { disabled: 'true', class: 'disable-notice', value: 'Поиск...' };
  }
  getOptionsDebounce(props.organization);
};
</script>

<style scoped></style>
